import React, { createContext, useReducer } from "react";

export const CodeContext = createContext();

const initialState = {
  code: '',
};

function reducer(state, action) {
  switch (action.type) {
    case "CODE":
      // console.log("context", action.data)
      return {
        ...state,
        code: action.data
      };
      case "GAMEID":
        // console.log("context", action.data)
        return {
          ...state,
          gameId : action.data
        };
    default:
      return state;
  }
}

export const CodeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <CodeContext.Provider value={value}>{children}</CodeContext.Provider>
  );
};
